var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('access-my-wallet-container'),_c('price-bar',{attrs:{"v-if":_vm.online && _vm.tokens.length > 1,"tokens":_vm.tokens}}),_c('faqs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }